<template>
  <base-modal :show="show" @close="close">
    <login-form v-if="!isLoggedIn" />
    <div v-if="isLoggedIn && showForm" class="modal__projectBook">
      <h2 class="modal__heading headingThree">{{ heading }}</h2>
      <p class="paragraph">{{ copy }}</p>

      <form class="modal__form">
        <div v-if="showProjectList">
          <label v-for="project in projects" :key="project.id" class="modal__projectRadio" @click.prevent="saveItemToProject(project.id)">
            <input type="radio" name="project" :value="project.id" checked>
            <span>{{ project.name }}</span>
          </label>
        </div>
        <label class="modal__newProject">
          <p class="paragraphSmall">Create a New Project</p>
          <input v-model="newProjectName" type="text" name="new project" placeholder="Project Name">
        </label>
        <input type="submit" value="Submit" @click.prevent="createProject">
      </form>
    </div>
    <div v-if="isLoggedIn && showSaved">
      <h2 class="modal__heading headingThree">Item saved to your Project Book</h2>
      <p class="paragraph">View your <a href="/project-book/">Project Book</a> now.</p>

      <p><a href="#!" class="button" @click.prevent="continueShopping">Continue browsing</a></p>
    </div>
  </base-modal>
</template>
<script>
import { eventBus } from '../app';
import axios from '../config/axios';

export default {
	props: {
		isAuthorised: {
			type: Boolean, 
			default: false 
		},
		siteId: {
			type: Number, 
			default: null 
		},
		initialProjects: {
			type: Array, 
			default: null
		},
		heading: {
			type: String, 
			default: ''
		},
		copy: {
			type: String, 
			default: ''
		}
	},
	data() {
		return {
			isLoggedIn: this.isAuthorised,
			show: false,
			newProjectName: null,
			selectedProjectId: null,
			projects: this.initialProjects,
			currentProjectItem: null,
			showForm: false,
			showProjectList: false,
			showSaved: false,
			afterProjectSave: null
		};
	},
	computed: {
		projectsPopulated() {
			return this.projects !== null;
		}
	},
	created() {
		document.addEventListener('keyup', (event) => {
			if (event.keyCode == 27) {
				this.toggleModal();
			}
		});

		eventBus.$on('login-success', this.authorised);
		eventBus.$on('save-product', this.saveProduct);
		eventBus.$on('save-multiple-products', this.saveMultipleProducts);
		eventBus.$on('save-project-only', this.saveProjectOnly);
	},
	beforeDestroy() {
		eventBus.$off('login-success', this.authorised);
		eventBus.$off('save-product', this.saveProduct);
		eventBus.$off('save-multiple-products', this.saveMultipleProducts);
		eventBus.$off('save-project-only', this.saveProjectOnly);
	},
	methods: {
		authorised() {
			this.isLoggedIn = true;
			this.fetchProjectsList();
		},
		close() {
			this.show = false;
		},
		toggleModal() {
			this.show = !this.show;
		},
		openModal() {
			this.show = true;
		},
		createProject() {
			const data = {
				name: this.newProjectName
			};

			axios.post('/actions/projectbook/projects/add', data).then(this.afterProjectSave);
		},
		addProjectAndSaveItem(response) {
			this.projects.push(response.data);
			this.selectedProjectId = response.data.id;
			this.saveItemToProject(this.selectedProjectId, this.siteId);
			this.newProjectName = null;
		},
		addProjectAndSaveItems(response) {
			this.projects.push(response.data);
			this.selectedProjectId = response.data.id;
			this.saveItemToProject(this.selectedProjectId, this.siteId);
			this.newProjectName = null;
		},
		addProjectOnly(response) {
			this.newProjectName = null;
			this.show = false;
			eventBus.$emit('project-created', { id: response.data.id, name: response.data.name });
		},
		saveItemToProject(id, siteId) {
			let data = {
				id: id,
				siteId: siteId,
				multipleItems: false
			};

			if (!this.currentProjectItem.multipleItems) {
				data.type = this.currentProjectItem.type,
				data.item = this.currentProjectItem.item
			}
			else {
				data.multipleItems = true;
				data.items = this.currentProjectItem.multipleItems;
			}

			axios.post('/actions/projectbook/project-item/add', data)
			.then(() => {
				this.currentProjectItem = null;
				this.showForm = false;
				this.showSaved = true;
			});
		},
		saveProduct(data) {
			this.afterProjectSave = this.addProjectAndSaveItem;
			this.currentProjectItem = data;
			this.showSaved = false;
			this.showProjectList = true;
			this.showForm = true;
			this.show = true;
		},
		saveMultipleProducts(data) {
			this.afterProjectSave = this.addProjectAndSaveItems;
			this.currentProjectItem = {
				multipleItems: data
			};
			this.showSaved = false;
			this.showProjectList = true;
			this.showForm = true;
			this.show = true;
		},
		saveProjectOnly() {console.log('saveProjectOnly called')
			this.afterProjectSave = this.addProjectOnly;
			this.showSaved = false;
			this.showForm = true;
			this.show = true;
		},
		continueShopping() {
			this.show = false;
		},
		fetchProjectsList() {
			axios.get('/actions/projectbook/projects/list', null)
			.then((response) => {
				this.projects = response.data;
			});
		}
	},
};
</script>
